document.addEventListener('DOMContentLoaded', function () {
    const variantSelect = document.querySelector('[name="id"]');
    const descriptionEl = document.getElementById("dynamic-description");
  
    if (!variantSelect || !descriptionEl || typeof window.variantDescriptions === "undefined") return;
  
    variantSelect.addEventListener("change", function () {
      const selectedVariantId = this.value;
      const newDescription = window.variantDescriptions[selectedVariantId];
  
      descriptionEl.innerHTML =
        newDescription && newDescription.trim() !== ""
          ? newDescription
          : window.defaultVariantDescription;
    });
  });